<footer data-qa="footer">
	<div class="bx--grid">
		<div class="footer"><span class="copyright">&copy;</span> Insight Data Solutions. {{ constants.dates.currentYear}} All rights reserved</div>
	</div>
</footer>
